import { z } from 'zod';
/** Cursor-based pagination. Never return unbounded lists. */
export const paginationQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const idSchema = z.string().uuid();
/** Unir registros duplicados (ciudadanos, juzgados): los `sourceIds` se funden en el que recibe la petición y desaparecen. */
export const mergeRecordsSchema = z.object({ sourceIds: z.array(idSchema).min(1).max(50) });
/** Actor kinds distinguished in timelines. */
export const ActorKind = {
    SYSTEM: 'SYSTEM',
    USER: 'USER',
    AI: 'AI',
    CITIZEN: 'CITIZEN',
    INTEGRATION: 'INTEGRATION',
};
export const AvailabilityStatus = {
    AVAILABLE: 'AVAILABLE',
    UNAVAILABLE: 'UNAVAILABLE',
    VACATION: 'VACATION',
    LEAVE: 'LEAVE',
    OFF_SHIFT: 'OFF_SHIFT',
    BLOCKED: 'BLOCKED',
};
/** Weight of each NIT digit, right to left (DIAN, módulo 11). */
const NIT_WEIGHTS = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
export const NIT_MAX_DIGITS = NIT_WEIGHTS.length;
/** Check digit (DV) of a Colombian NIT, given only its digits, as the DIAN computes it. */
export function nitCheckDigit(nit) {
    if (!/^\d+$/.test(nit) || nit.length > NIT_MAX_DIGITS)
        throw new Error(`NIT inválido: «${nit}»`);
    let sum = 0;
    for (let i = 0; i < nit.length; i++)
        sum += Number(nit[nit.length - 1 - i]) * NIT_WEIGHTS[i];
    const rest = sum % 11;
    return rest > 1 ? 11 - rest : rest;
}
//# sourceMappingURL=common.js.map